import { render } from "./HeroBackground.vue?vue&type=template&id=20e4d108&scoped=true"
import script from "./HeroBackground.vue?vue&type=script&lang=js"
export * from "./HeroBackground.vue?vue&type=script&lang=js"

import "./HeroBackground.vue?vue&type=style&index=0&id=20e4d108&lang=scss&scoped=true"

import exportComponent from "/proyectos/programas-de-investigacion/cah-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20e4d108"]])

export default __exports__